import { render, staticRenderFns } from "./EditDestinationPost.vue?vue&type=template&id=16ed1fce&scoped=true"
import script from "./EditDestinationPost.vue?vue&type=script&lang=js"
export * from "./EditDestinationPost.vue?vue&type=script&lang=js"
import style0 from "./EditDestinationPost.vue?vue&type=style&index=0&id=16ed1fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ed1fce",
  null
  
)

export default component.exports